<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm7>
                <v-text-field
                  label="论著名称"
                  required
                  :rules="rules.required"
                  counter="150"
                  v-model="item.name"/>
              </v-flex>

              <v-flex xs12 sm5>
                <v-select
                  label="校内主管部门"
                  clearable
                  required
                  :rules="rules.required"
                  @change = "onSelectAdmin"
                  v-model="item.adminDeptId"
                  item-text="name"
                  item-value="dbid"
                  :items="adminDeptItems"
                />
              </v-flex>

              <v-flex xs12>
                <x-authors
                  label="作者列表"
                  v-model="item.authors"
                  hint="填写作者列表"
                />

              </v-flex>

              <v-flex xs3>
                <v-text-field
                  label="ISBN"
                  required
                  :rules="rules.required"
                  v-model="item.isbn"/>
              </v-flex>

              <v-flex xs3>
                <v-select
                  label="单位署名情况"
                  clearable
                  required
                  :rules="rules.named"
                  :items="[{value:true, text:'署名'},{value:false, text:'未署名'}]"
                  v-model="item.named"
                />
              </v-flex>

              <v-flex xs3>
                <v-select
                  label="论著类别"
                  clearable
                  required
                  :rules="rules.required"
                  v-model="item.typeId"
                  item-text="name"
                  item-value="dbid"
                  :items="typeItems"
                />
              </v-flex>

              <v-flex xs3>
                <v-select
                    label="论著级别"
                    clearable
                    required
                    v-model="item.levelId"
                    item-text="name"
                    item-value="dbid"
                    persistent-hint
                    hint="仅人文社科类专著需要选择此项！"
                    :disabled = "disnaLevel"
                    :items="levelItems"
                />
              </v-flex>

              <v-flex xs2>
                <v-text-field
                  label="总字数"
                  required
                  :rules="rules.wordCount"
                  v-model="item.wordCount"
                  hint="单位：万字"
                  persistent-hint
                />
              </v-flex>

              <v-flex xs5>
                <v-autocomplete
                  label="论著属性"
                  clearable
                  required
                  :rules="rules.required"
                  v-model="item.subjectTypeId"
                  item-text="name"
                  item-value="dbid"
                  :items="subjectTypeItems"
                />
              </v-flex>

              <v-flex xs5>
                <v-autocomplete
                  label="所属学科"
                  clearable
                  required
                  v-model="item.subjectId"
                  :rules="rules.required"
                  item-text="name"
                  item-value="dbid"
                  :items="subjectItems"
                />
              </v-flex>

              <v-flex xs8>
                <v-text-field
                  label="出版单位"
                  required
                  v-model="item.publisher"
                  :rules="rules.name"
                  counter="150"
                />
              </v-flex>

              <v-flex xs4>
                <v-menu
                  ref="publDateMenuRef"
                  lazy
                  :close-on-content-click="false"
                  v-model="publDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="出版时间"
                    v-model="item.publDate"
                    :rules="rules.publDate"
                    hint="格式YYYY-MM-DD, 如：2018-10"
                    persistent-hint
                  />

                  <v-date-picker
                    v-model="publDate"
                    locale="zh-cn"
                    @change="nv => item.publDate= nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex xs9>
                <v-autocomplete
                  label="归属部门"
                  clearable
                  required
                  v-model="item.deptId"
                  :rules="rules.required"
                  item-text="name"
                  item-value="dbid"
                  :items="deptItems"
                />
              </v-flex>

              <v-flex xs3>
                <v-select
                  label="出版地"
                  clearable
                  required
                  :items="['境内', '境外']"
                  v-model="item.address"
                  :rules="rules.required"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="备注"
                  v-model="item.note"
                  :rules="rules.note"
                />
              </v-flex>

              <v-flex xs12>
                <x-uploader
                  label="附件列表"
                  :action="fileUri"
                  v-model="item.attachments"
                  :size="Number(50)"
                  description="单个附件大小不超过 50M."
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

  import mixin from '@/mixin'
  import XAuthors from './widgets/Authors'


  import XUploader from '@/components/global/Uploader'

  const baseURI = '/api/book/book';
  const typeURI = '/api/book/type';
  const subjectURI = '/api/code/subject';
  const subjectTypeURI = '/api/code/subject';
  const deptURI = '/api/syst/department';
  const levelURI = '/api/book/level';

  export default {
    mixins: [mixin.edit(baseURI)],
    components: {XAuthors,XUploader},

    data() {
      return {
        formValid: false,

        fileUri:'/api/book/file',

        item: {},
        freshItem: {
          "name": null,
          "authors": [],
          "subjectTypeId": null,
          "subjectId": null,
          "publisher": null,
          "address": null,
          "isbn": null,
          "typeId": null,
          "levelId": null,
          "named": null,
          "wordCount": null,
          "statusId": null,
          "deptId": null,
          "publDate": null,
          "note": null
        },

        publDateMenu: false,
        publDate:null,

        typeItems: [],
        subjectItems: [],
        subjectTypeItems: [],
        deptItems: [],
        adminDeptItems: [],
        levelItems: [],

        disnaLevel : true,

        /**
         * 验证规则
         */
        rules: {
          name: [
            v => !!v || '必填项。',
            v => (v && v.length <= 150) || '长度必须小于150个字符。'
          ],
          required: [
            v => !!v || '必填项。'
          ],
          named: [
            v => (v === true || v === false) || '必填项。'
          ],
          wordCount: [
            v => !!v || '必填项。',
            v => (v && /^\d+(\.\d{1,2})?$/.test(v)) || '填写整数或小数,小数点后最多两位。'
          ],
          note: [v => (!v || v.length <= 255) || '长度必须小于255个字符。'],
          publDate: [
            v => !!v || "必填项。",
            v => window.xutil.regexpDate().test(v) || '日期格式错误'
          ],
        }
      }
    },

    created() {
      this.axios.all([
        this.axios.get(deptURI, {params: {limit: 65535, disabled: 'F'}}),
        this.axios.get(subjectURI, {params: {limit: 65535, disabled: 'F', codeIsNotNull: true, sort: 'order.asc'}}),
        this.axios.get(typeURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
        this.axios.get(subjectTypeURI, {params: {limit: 65535, disabled: 'F', codeIsNull: true, sort: 'order.asc'}}),
        this.axios.get(levelURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
      ]).then(
        this.axios.spread(
          (rspDept, rspSubj, rspType, rspSubjType, rspLevel) => {
            this.deptItems = rspDept.data.items;
            this.subjectItems = rspSubj.data.items;
            this.typeItems = rspType.data.items;
            this.subjectTypeItems = rspSubjType.data.items;
            this.levelItems = rspLevel.data.items;
            this.adminDeptItems = rspDept.data.items
              .filter(v => v.isAdmin && (!/公司$/ig.test(v.name)))
              .reverse();          }
        )
      )
    },

    watch: {},

    methods: {
      onSelectAdmin() {
        window.console.log("选择管理部门")
        if(this.item.adminDeptId === 'Db2NIJQbgCY')
        {
          this.disnaLevel = false
        }
        else {
          this.disnaLevel = true
        }
      },
    }
  }
</script>
